import StackedBarChart from '@/components/molecules/Charts/StackedBarChart';
import APP_CONFIG from '@/config/app';
import { UnderlyingYieldBearingAssetInterface } from '@/interfaces';
import { FC } from 'react';
interface YieldBearingAssetUnderlyingYieldBearingAssetAllocationChartProps {
  underlyingYieldBearingAssets: UnderlyingYieldBearingAssetInterface[];
  className?: string;
}
const YieldBearingAssetUnderlyingYieldBearingAssetAllocationChart: FC<
  YieldBearingAssetUnderlyingYieldBearingAssetAllocationChartProps
> = ({ underlyingYieldBearingAssets, className }) => {
  const availableColors = APP_CONFIG.TOKEN_COLORS;
  const items = underlyingYieldBearingAssets.map((asset, index) => ({
    width: asset.composition * 100,
    color: availableColors[index % availableColors.length],
    label: asset.symbol,
  }));
  return <StackedBarChart items={items} className={`${className}`} />;
};
export default YieldBearingAssetUnderlyingYieldBearingAssetAllocationChart;
